/*

class to generate a slot

https://www.hl7.org/fhir/slot.html

{
  "state" : "<code>", // R!  busy | free | busy-unavailable | busy-tentative | entered-in-error
  "userType" : "<code>", // orgAdmin || providerAP || providerLP || patient
  "userId" : "<String>"
  "scheduleId" : { Reference(Schedule) }, // R!  The schedule resource that this slot defines an interval of status information
  "serviceCategory" : [{ code }], // A broad categorization of the service that is to be performed during this appointment
  "serviceType" : [{ code }], // The type of appointments that can be booked into this slot (ideally this would be an identifiable service - which is at a location, rather than the location itself). If provided then this overrides the value provided on the availability resource
  "specialty" : [{ code }], // The specialty of a practitioner that would be required to perform the service requested in this appointment
  "appointmentType" : { code }, // The style of appointment or patient that may be booked in the slot (not service type)
  "start" : "<instant>", // R!  Date/Time that the slot is to begin
  "end" : "<instant>", // R!  Date/Time that the slot is to conclude
  "overbooked" : <boolean>, // This slot has already been overbooked, appointments are unlikely to be accepted for this time
  "comment" : "<string>" // Comments on the slot to describe any extended information. Such as custom constraints on the slot
}

*/

// Import libraries
const Joi = require('joi');

// Import variables
const { STATES, USER_TYPES } = require('@bcm/constants');
const { joiValidateObj, identifiers } = require('../datastructComponents');
const { DataTableBase } = require('./base.class');
const { codeSchema } = require('./code.class');

// Create schema
const schema = {
  identifier: Joi.any().optional(),
  state: Joi.string().valid( ...Object.keys(STATES) ).required(),
  userType: Joi.string().valid( ...Object.keys(USER_TYPES) ).required(),
  userId: Joi.string().required(),
  scheduleId: Joi.string().required(),
  slotId: Joi.string().required(),
  serviceCategory:  Joi.array().items(codeSchema).optional(),
  serviceType: Joi.array().items(codeSchema).optional(),
  specialty: Joi.array().items(codeSchema).optional(),
  appointmentType: codeSchema,
  start: Joi.string().required(),
  end: Joi.string().required(),
  overbooked: Joi.boolean().optional(),
  comment: Joi.string().optional(),
};

// Define class
class Slot extends DataTableBase {
  constructor ( obj ) {
    joiValidateObj(schema, obj);
    super (
      identifiers.slot.buildPk(obj.scheduleId),
      identifiers.slot.buildSk(obj.state, obj.userType, obj.userId, obj.scheduleId, obj.slotId)
    );
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.Slot = Slot;
exports.slotSchema = schema;